// File: src/utils/toast.js
// Lightweight fixed-position toast utility.
// Usage: import { toast } from '../utils/toast';
//        toast.success('Saved!');
//        toast.error('Something went wrong.');
//        toast.info('Note: ...');

const dispatch = (type, message, duration = 4000) => {
  document.dispatchEvent(
    new CustomEvent('bipzapp:toast', { detail: { type, message, duration, id: Date.now() } })
  );
};

export const toast = {
  success: (message, duration)  => dispatch('success', message, duration),
  error:   (message, duration)  => dispatch('error',   message, duration),
  info:    (message, duration)  => dispatch('info',    message, duration),
};